__turbopack_context__.v({
  "breadcrumb": "Breadcrumbs-module-scss-module__PA0s_q__breadcrumb",
  "breadcrumbs": "Breadcrumbs-module-scss-module__PA0s_q__breadcrumbs",
  "label": "Breadcrumbs-module-scss-module__PA0s_q__label",
  "link": "Breadcrumbs-module-scss-module__PA0s_q__link",
  "main": "Breadcrumbs-module-scss-module__PA0s_q__main",
  "pdf": "Breadcrumbs-module-scss-module__PA0s_q__pdf",
  "truncate": "Breadcrumbs-module-scss-module__PA0s_q__truncate",
});
